module.exports = __webpack_public_path__ + "static/img/ikona_cw7-OFF.12e8b73c.png";